import { Immutable } from "immer";
import React from "react";
import { CartReferenceNumber } from "tsi-common-react/src/apps/checkout/CartReferenceNumber";
import { Link } from "tsi-common-react/src/components/Link/index";
import { SVGIcon } from "tsi-common-react/src/components/SVGIcon/index";
import { isoWebPageURL } from "tsi-common-react/src/models/nominals";
import { jt, t } from "ttag";

import { templates } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import siteNavStyles from "../../styles/composable/site-nav.module.scss";
import styles from "./index.module.scss";

type IProps = Immutable<templates.CheckoutHeaderTemplate>;

export const CheckoutHeader = (props: IProps): React.JSX.Element => {
    const secure = (
        <span
            key="secure"
            className={styles.checkoutHeaderHeaderBold}
        >{t`secure`}</span>
    );
    const secureCheckout = jt`${secure} checkout`;
    const urlPageLink = isoWebPageURL.wrap(props.root_page_url);
    return (
        <header className="l-full-width">
            <nav
                className={concatClassNames([
                    "site-nav",
                    siteNavStyles.siteNav,
                    styles.checkoutHeader,
                ])}
            >
                <div
                    className={concatClassNames([
                        siteNavStyles.siteNavContent,
                        styles.checkoutHeaderContent,
                        "l-capped-width",
                    ])}
                >
                    <Link
                        className={siteNavStyles.siteNavLogoLink}
                        href={urlPageLink}
                    >
                        {/* TODO(i18n): Translate alt attribute value with t tagged template */}
                        <SVGIcon
                            svgClassName={siteNavStyles.siteNavPillowsLogo}
                            name="pillowsLogo"
                            alt="TEMPUR-PILLOWS FROM TEMPUR-PEDIC®"
                        />
                    </Link>
                    <Link
                        className={concatClassNames([
                            siteNavStyles.siteNavLogoLinkMobile,
                            styles.logoLinkMobile,
                        ])}
                        href={urlPageLink}
                    >
                        {/* TODO(i18n): Translate alt attribute value with t tagged template */}
                        <SVGIcon
                            name="pillowsLogo"
                            alt="TEMPUR-PILLOWS FROM TEMPUR-PEDIC®"
                        />
                    </Link>
                    <h1 className={styles.checkoutHeaderHeader}>
                        {secureCheckout}
                    </h1>

                    <div className={styles.checkoutHeaderHeaderCartRef}>
                        <CartReferenceNumber
                            encodedBasketID={props.encoded_basket_id}
                            phoneNumber={props.support_website_phone_number}
                        />
                    </div>
                </div>
            </nav>
        </header>
    );
};
